"use client";

import { Instagram, Music2, Twitter, Youtube, ShieldCheck, CreditCard, Lock } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
const shopLinks = [{
  label: "Property Management",
  to: "/ManagementPage"
}, {
  label: "Fractional Admin",
  to: "/ManagementPage"
}, {
  label: "Rental Yields",
  to: "/ManagementPage"
}, {
  label: "Owner Reporting",
  to: "/ManagementPage"
}];
const dropsLinks = [{
  label: "Exit Strategy",
  to: "/ExitStrategyPage"
}, {
  label: "Timeshare Transfer",
  to: "/ExitStrategyPage"
}, {
  label: "Legal Compliance",
  to: "/ExitStrategyPage"
}, {
  label: "Exit Assessment",
  to: "/ExitStrategyPage"
}];
const helpLinks = [{
  label: "Concierge Services",
  to: "/HospitalityPage"
}, {
  label: "Private Transport",
  to: "/HospitalityPage"
}, {
  label: "Marine Charters",
  to: "/HospitalityPage"
}, {
  label: "Real Estate Sales",
  to: "/RealEstatePage"
}];
const companyLinks = [{
  label: "Home",
  to: "/HomePage"
}, {
  label: "About IMI",
  to: "/HomePage"
}, {
  label: "Contact Us",
  to: "/ContactPage"
}, {
  label: "Partners",
  to: "/PartnersPage"
}];
const columns = [{
  title: "Management",
  links: shopLinks
}, {
  title: "Solutions",
  links: dropsLinks
}, {
  title: "Hospitality",
  links: helpLinks
}, {
  title: "Company",
  links: companyLinks
}];
const socials = [{
  label: "Instagram",
  to: "#",
  icon: Instagram
}, {
  label: "TikTok",
  to: "#",
  icon: Music2
}, {
  label: "X",
  to: "#",
  icon: Twitter
}, {
  label: "YouTube",
  to: "#",
  icon: Youtube
}];
export default function FooterLegal() {
  return <section data-section-id="1992" id="footer-legal" className="relative overflow-hidden dark bg-background text-white border-t-2 border-primary">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
        <span className="font-serif font-bold leading-none tracking-tighter text-white/[0.03] text-[28vw] md:text-[22vw]">
          IMI
        </span>
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        {}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          {}
          <div className="lg:col-span-4">
            <Link to="/" aria-label="IMI Elite Management home" className="inline-block">
              <WvcLogo className="h-10 w-auto" />
            </Link>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white font-default">
              Architects of asset liberation and luxury hospitality. 29 years of resort expertise, PROFECO-compliant, and SAT registered.
            </p>
          </div>

          {}
          <div className="hidden lg:col-span-8 lg:grid lg:grid-cols-4 lg:gap-8">
            {columns.map((col, i) => <div key={i} data-index={i}>
                <h3 className="font-default text-xs font-semibold uppercase tracking-widest text-white">
                  {col.title}
                </h3>
                <ul className="mt-5 space-y-3">
                  {col.links.map((link, j) => <li key={j} data-index={j}>
                      <Link to={link.to} className="text-[13px] uppercase tracking-wide text-white transition-colors hover:text-primary font-default">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>

          {}
          <div className="lg:hidden">
            <Accordion type="single" collapsible className="w-full">
              {columns.map((col, i) => <AccordionItem key={i} data-index={i} value={col.title} className="border-border">
                  <AccordionTrigger className="font-default text-xs font-semibold uppercase tracking-widest text-white hover:no-underline">
                    {col.title}
                  </AccordionTrigger>
                  <AccordionContent>
                    <ul className="space-y-3 pt-1">
                      {col.links.map((link, j) => <li key={j} data-index={j}>
                          <Link to={link.to} className="text-[13px] uppercase tracking-wide text-white transition-colors hover:text-primary font-default">
                            {link.label}
                          </Link>
                        </li>)}
                    </ul>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="flex flex-col items-center gap-8 lg:flex-row lg:justify-between">
          {}
          <div className="flex items-center gap-3">
            {socials.map((social, i) => {
            const Icon = social.icon;
            return <Button key={social.label} data-index={i} asChild variant="outline" size="icon" className="size-10 rounded-md border-border bg-transparent text-white transition-colors hover:bg-primary hover:text-primary-foreground hover:border-primary">
                  <Link to={social.to} aria-label={social.label} newTab>
                    <Icon className="size-4" />
                  </Link>
                </Button>;
          })}
          </div>

          {}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-white">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-wide font-default">
              <ShieldCheck className="size-4 text-primary" />
              PROFECO Compliant
            </span>
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-wide font-default">
              <Lock className="size-4 text-primary" />
              SAT Registered
            </span>
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-wide font-default">
              <CreditCard className="size-4 text-primary" />
              Secure Transactions
            </span>
          </div>
        </div>

        <div className="mt-10 flex flex-col lg:flex-row lg:justify-between gap-4 text-center lg:text-left">
          <p className="text-xs text-white font-default">
            &copy; {new Date().getFullYear()} IMI Elite Management. All rights reserved.
          </p>
          <p className="text-[10px] text-white/60 max-w-2xl font-default leading-relaxed">
            Legal Disclaimer: IMI Elite Management operates in full compliance with Mexican real estate laws. Timeshare exit services are subject to legal review and contract terms. No upfront costs apply to specific qualified exit programs.
          </p>
        </div>
      </div>
    </section>;
}